import { Splitter, SplitterOnChangeEvent, SplitterPaneProps } from '@progress/kendo-react-layout';
import React, { useState, useEffect } from 'react';
import { TwoColsSplitterProps } from './two-cols-splitter.interface';
import './styles.scss';
import { updateGridDetailsWidth } from '@utils/grid-v2';
import cn from 'clsx';

const TwoColsSplitter = ({
    leftCol,
    rightCol,
    orientation,
    alignmentValues,
    onResize,
    className,
}: TwoColsSplitterProps) => {
    const panesSettings = !!alignmentValues
        ? alignmentValues
        : [
              { min: '20%' },
              {
                  min: '20%',
                  size: '30%',
                  keepMounted: true,
              },
          ];
    const [panes, setPanes] = useState<Array<SplitterPaneProps>>(panesSettings);

    useEffect(() => {
        if (onResize) {
            onResize();
        }
        updateGridDetailsWidth();
    }, [orientation]);

    const onChange = (event: SplitterOnChangeEvent) => {
        setPanes(event.newState);
        if (event.isLast) {
            if (onResize) {
                onResize();
            }
            updateGridDetailsWidth();
        }
    };

    return (
        <Splitter
            panes={panes}
            onChange={onChange}
            orientation={orientation}
            className={cn('opra-splitter', className)}
        >
            <div className="pane-content">{leftCol}</div>
            <div className="pane-content">{rightCol}</div>
        </Splitter>
    );
};

export default TwoColsSplitter;
